import { layoutBand } from '../../lib/calendar/timeGridLayout';
import { EventTagChip } from './EventTagChip';

/**
 * The all-day band above the Week/Day hour grid (#679). All-day and ≥24h
 * events sit here — spanning the columns they cover — instead of being placed
 * at midnight in the hour grid, which is where the old views put them.
 *
 * Renders nothing when there is nothing to show, so a quiet week keeps the
 * prototype's look (the prototype has no band at all).
 */
export function AllDayBand({ entries, dayKeys, onEventClick, displayZone, gutterPx }) {
    const rows = layoutBand(entries, dayKeys);
    if (!rows.length) return null;
    const rowCount = Math.max(...rows.map(r => r.row)) + 1;
    return (
        <div className="flex flex-none border-b border-[#EDEBE6] bg-white" data-testid="calendar-all-day-band">
            <div
                className="flex-none border-r border-[#F2F0EC] flex items-start justify-end pr-[9px] pt-1.5 text-[10.5px] text-[#A29B95]"
                style={{ width: gutterPx }}
            >
                All day
            </div>
            <div
                className="flex-1 min-w-0 grid gap-y-[3px] px-1 py-1"
                style={{
                    gridTemplateColumns: `repeat(${dayKeys.length}, minmax(0, 1fr))`,
                    gridTemplateRows: `repeat(${rowCount}, auto)`,
                }}
            >
                {rows.map(r => (
                    <div
                        key={`${r.event.event_id}-${r.startCol}`}
                        className="min-w-0 px-0.5"
                        style={{ gridColumn: `${r.startCol + 1} / ${r.endCol + 2}`, gridRow: r.row + 1 }}
                    >
                        <EventTagChip event={r.event} onClick={onEventClick} displayZone={displayZone} />
                    </div>
                ))}
            </div>
        </div>
    );
}
